import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppConfiguration } from './core/types';
import { initSKStarterOnGlobal } from './appinit';
import { AppContext, createAppContext } from './appContext';

export function startSKApp(containerId : string, cfg : AppConfiguration) {
  // eslint-disable-line
  const appCfg : AppConfiguration = cfg || (window as any).configuration || {
    initialized : false,
    projectId : "",
    view : "editor",
    domain : "localhost",
    domainPath : "/assets/domains/"
  };

  const instanceId = containerId || 'root';

  const container = document.getElementById(instanceId);
  if (!container) return;

  console.log("App:"+instanceId+" Intializing Sandkasten with Cfg ", appCfg);
  const root = createRoot(container);
  // StrictMode vorübergehend deaktiviert zum Testen: verursacht in React 18 doppelte
  // useEffect-Ausführung → doppelte Requests → Browser bricht erste Verbindung ab → ECONNRESET im Proxy.
  root.render(
    <AppContext instanceId={instanceId}>
      <App configuration={appCfg} id={instanceId} />
    </AppContext>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}

initSKStarterOnGlobal();